import { supabase } from './supabase';

const PRODUCT_SESSION_ID_KEY = 'stockvested-product-session-id';

function createSessionId() {
  if (
    typeof window !== 'undefined' &&
    window.crypto &&
    typeof window.crypto.randomUUID === 'function'
  ) {
    return window.crypto.randomUUID();
  }

  return `session-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getProductSessionId(userId) {
  if (typeof window === 'undefined' || !userId) {
    return null;
  }

  const storageKey =
    `${PRODUCT_SESSION_ID_KEY}:${userId}`;

  let sessionId =
    window.sessionStorage.getItem(storageKey);

  if (!sessionId) {
    sessionId = createSessionId();

    window.sessionStorage.setItem(
      storageKey,
      sessionId
    );
  }

  return sessionId;
}

export async function trackProductEvent({
  userId,
  eventName,
  analysisId = null,
  journalEntryId = null,
  ticker = null,
  metadata = {},
}) {
  if (!userId || !eventName) return false;

  try {
    const { error } = await supabase.from('product_events').insert({
      user_id: userId,
      event_name: eventName,
      session_id: getProductSessionId(userId),
      analysis_id: analysisId,
      journal_entry_id: journalEntryId,
      ticker: ticker ? String(ticker).toUpperCase() : null,
      metadata:
        metadata && typeof metadata === 'object'
          ? metadata
          : {},
    });

    if (error) throw error;

    console.log('[product-event]', eventName, {
      analysisId,
      journalEntryId,
      ticker,
      metadata,
    });

    return true;
  } catch (error) {
    /*
      Product analytics must never break an analysis, journal save,
      page view or checkout attempt.
    */
    console.error('[product-event] failed:', eventName, error);
    return false;
  }
}

export async function trackProductEventOncePerSession({
  userId,
  eventName,
  dedupeKey = eventName,
  ...eventData
}) {
  if (!userId || !eventName || typeof window === 'undefined') {
    return false;
  }

  const storageKey =
    `stockvested-product-event:${userId}:${dedupeKey}`;

  if (window.sessionStorage.getItem(storageKey) === '1') {
    return true;
  }

  window.sessionStorage.setItem(storageKey, '1');

  const succeeded = await trackProductEvent({
    userId,
    eventName,
    ...eventData,
  });

  if (!succeeded) {
    window.sessionStorage.removeItem(storageKey);
  }

  return succeeded;
}